export const css = {
  button: 'text-sm text-white w-28',
  helper: 'font-medium text-center text-gray-300 text-sm',
  selected: 'border-gray-300 bg-gray-200/10',
};
